import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { OrderProviderExternalErrorRatioChart } from 'types/embedded/orderProviderExternalErrors';

import {
  OrderProviderExternalErrorsRatioChartHintBox,
  OrderProviderExternalErrorsRatioChartScrollBox,
  OrderProviderExternalErrorsRatioChartTotalStyled,
  StyledCard,
  StyledCardHeader,
} from './OrderProviderExternalErrorsRatioChart.styled';
import { OrderProviderExternalErrorsRatioChartBar } from './OrderProviderExternalErrorsRatioChartBar';
import { OrderProviderExternalErrorsRatioChartHint } from './OrderProviderExternalErrorsRatioChartHint';
import { OrderProviderExternalErrorsRatioChartSkeleton } from './OrderProviderExternalErrorsRatioChartSkeleton';

type Props = { data?: OrderProviderExternalErrorRatioChart };

export const OrderProviderExternalErrorsRatioChart: React.FC<Props> = ({ data }) => {
  const translate = useTypedTranslate();

  if (!data) {
    return <OrderProviderExternalErrorsRatioChartSkeleton />;
  }

  return (
    <StyledCard>
      <StyledCardHeader
        description={translate('app.orderProviderExternalErrors.byProvidersForPeriod')}
        descriptionProps={{ fontSize: '12px' }}
        title={translate('app.orderProviderExternalErrors.declineRatio')}
        titleSize="small"
      />
      <CardContent sx={{ padding: '0 !important' }}>
        <OrderProviderExternalErrorsRatioChartTotalStyled>
          <OrderProviderExternalErrorsRatioChartBar
            title={translate('app.orderProviderExternalErrors.totalCount')}
            {...data?.totalRatio}
          />
        </OrderProviderExternalErrorsRatioChartTotalStyled>
        <OrderProviderExternalErrorsRatioChartScrollBox>
          {data?.ratioByProviders?.map((ratio, index) => (
            <OrderProviderExternalErrorsRatioChartBar {...ratio} key={index} />
          ))}
        </OrderProviderExternalErrorsRatioChartScrollBox>
        <OrderProviderExternalErrorsRatioChartHintBox>
          <OrderProviderExternalErrorsRatioChartHint
            color="success"
            title={translate('app.orderProviderExternalErrors.totalOrders')}
          />
          <OrderProviderExternalErrorsRatioChartHint
            color="error"
            title={translate('app.orderProviderExternalErrors.declines')}
          />
        </OrderProviderExternalErrorsRatioChartHintBox>
      </CardContent>
    </StyledCard>
  );
};
